//loading
window.onload = function () {
    const elements = document.getElementsByClassName('secMainView__img');
    const txt_en = document.getElementById('js-secMainView__catch__en');
    const txt_ja = document.getElementById('js-secMainView__catch__ja');
    Array.prototype.forEach.call(elements, function (element) {
        element.classList.add("loaded");
    });
    txt_en.classList.add('loaded');
    txt_ja.classList.add('loaded');
}


//call simpleParallax
var image = document.getElementsByClassName('parallax');
new simpleParallax(image, {
    scale: 1.1,
    orientation: 'down',
    delay: .6,
    transition: 'cubic-bezier(0,0,0,1)'
});


//call swiper
//news
var swiper_news = undefined;
var winW = window.innerWidth;
var swiperElement = document.getElementById("news-slider");
var swiperWrapper = swiperElement.getElementsByClassName(".secNews__list");
var swiperSlide = swiperElement.getElementsByClassName("secNews__item");
var options = {
    slidesPerView: 1,
    // loop: true,
    navigation: {
        nextEl: ".secNews .swiper-button-next",
        prevEl: ".secNews .swiper-button-prev"
    }
};
function initSwiper() {
    if (swiperElement) {
        var screenWidth = window.innerWidth;
        if (screenWidth < 750 && swiper_news == undefined) {
            swiper_news = new Swiper('#news-slider', options);
        } else if (screenWidth > 751 && swiper_news != undefined) {
            swiper_news.destroy();
            swiper_news = undefined;
            for (var i = 0; i < swiperWrapper.length; i++) {
                swiperWrapper[i].removeAttribute('style');
            }
            for (var i = 0; i < swiperSlide.length; i++) {
                swiperSlide[i].removeAttribute('style');
            }
        }
    }
}
initSwiper();
window.addEventListener('resize', initSwiper);


//ranking
const swiper_ranking = new Swiper('.secRanking .swiper-container', {
    slidesPerView: 'auto',
    spaceBetween: 16,
    autoHeight: true,
    loop: true,
    loopAdditionalSlides: 1,
    autoplay: {
        delay: 3500,
    },
    speed: 1000,
    pagination: {
        el: '.secRanking .swiper-pagination',
    },
    breakpoints: {
        750: {
            slidesPerView: 3.8,
            spaceBetween: 25,
            autoHeight: false,
        },
        980: {
            slidesPerView: 4.8,
            spaceBetween: 25,
            autoHeight: false,
        },
    }
});


// call intersectAciton
const observerOptions = {
    root: null,
    rootMargin: '-30%',
    threshold: 0
}
const fadeInUpAll = document.querySelectorAll('.anim-bg');
intersectAction(fadeInUpAll, function (element, isIntersecting) {
    if (isIntersecting) {
        element.classList.add('-on');
    }
}, observerOptions)

//accordion
const accordion = document.getElementById("js-accordion");
const accordion_button = document.getElementById("js-accordion-button");
accordion_button.addEventListener('click', () => {
    accordion.classList.toggle('open');
    accordion_button.classList.toggle('open');
});


//motionPath
function motionPathInit() {
    var tl1 = new gsap.timeline();
    var line1 = document.getElementById('js-line1');
    gsap.set(line1, {
        y: 18,
        x: 40
    });
    gsap.set(".js-line1Text .word .char", {
        x: -9999
    });
    tl1.to('.js-line1Text .word .char, .js-line1Text .whitespace', {
        motionPath: {
            path: '#js-line1',
            align: '#js-line1',
            alignOrigin: [0.5, 1],
            autoRotate: true
        },
        stagger: {
            each: 0.075,
            repeat: -1
        },
        duration: 15,
        runBackwards: true,
        ease: "none"
    });
};
motionPathInit();

//call splitting-lite.min.js
// Splitting({
//     whitespace: true
// })
